import {
  generateMobileSourcesForPicture,
  generateDesktopSourcesForPicture,
} from '@farmersdog/corgi-x';

import backgroundPng from './background.png';
import backgroundJpg from './background.jpg';
import backgroundWebp from './background.webp';

import backgroundMobilePng from './background-mobile.png';
import backgroundMobileJpg from './background-mobile.jpg';
import backgroundMobileWebp from './background-mobile.webp';

export const background = generateDesktopSourcesForPicture({
  webP: backgroundWebp,
  jpg: backgroundJpg,
  png: backgroundPng,
});

export const backgroundMobile = generateMobileSourcesForPicture({
  webP: backgroundMobileWebp,
  jpg: backgroundMobileJpg,
  png: backgroundMobilePng,
});
